export const CONDITION_INVENTORY = ["Rusak", "Normal", "Hilang"];
export const CONDITION_INVENTORY_MODEM_COLOR = ["warning", "success", "danger"];